import React from 'react'
import styled from 'styled-components'
import { Button } from '../../designSystem'
import { handleEventLog } from '../../lib/utils'

const Container = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #181b25;
  color: white;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  img {
    margin-right: 8px;
  }
`

const TextDiv = styled.div`
  flex: 1;
  padding-right: 8px;
  h5 {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
  }
`

const CrossButton = styled.button`
  position: absolute;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #b7b9c3;
  border-radius: 50%;
  color: white;
  bottom: 56px;
  right: 3px;
  z-index: 4;
  outline: none;
  border: none;
  padding: 4px;
  cursor: pointer;

  img {
    width: 14px;
    margin: 0;
  }

  @media (max-width: 490px) {
    bottom: 70px;
  }
`

function SignUpBox({ handleSignUp, setSignUpBoxActive }) {

  const handleClose = () => {
    handleEventLog("writer_academy", "button_click", {
      module_name : 'close'
    } )
    setSignUpBoxActive(false)
  }

  return (
    <Container>
      <CrossButton onClick={handleClose} className='underObsevation' id='Cross'>
        <img src="/images/close.png" alt="x" />{' '}
      </CrossButton>
      <img src="/images/writers_logo.svg" alt="" />
      <TextDiv>
        <h3>Pocket Writer</h3>
        <h5>START WRITING FOR MILLIONS WITH POCKET WRITER</h5>
      </TextDiv>
      <Button 
        variant="fillPrimary" 
        onClick={()=> handleSignUp('join_now')}
        className='underObsevation'
        id='JoinNow'
      >
        JOIN NOw
      </Button>
    </Container>
  )
}

export default SignUpBox
